import axios from '../plugins/axios'

export default {
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',

      new_password: '',
      confirm_password: '',
      first_name: '',
      last_name: '',
      billing_company: '',
      billing_phone: '',
    }
  },
  methods: {
    complete_registration () {
      if (this.loading) {
        return
      }

      this.loading = true

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    submit () {
      const formData = new FormData(this.$el)

      this.loading = true

      this.messageType = 'error'
      this.errors.clear()

      axios.post('', formData)
        .then(response => {
          location.href = response.data.data.redirect
        })
        .catch(error => {
          this.messageType = 'error'

          for (const errorKey in error.response.data.data) {
            this.errors.add({
              field: errorKey,
              msg: error.response.data.data[errorKey],
            })
          }

          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/complete_registration.js